// extracted by mini-css-extract-plugin
export default {"field-label":"field-label__81f432"};